module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Epigraph"
  }, [_vm._v("“At the center of this story is not a diamond, a painting, or a suitcase full of bills, but a book. Some would say it is the book: the authoritative copy of a text whose position at the root of more than one civilization has given it bearing on the lives of billions of people, even if they have never read it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPigraph-2"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("ATTI ")]), _vm._v("F"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("RIEDMAN")]), _vm._v(", "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("The Aleppo Codex")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Epigraph"
  }, [_vm._v("“Just sitting down five minutes drinking a cup of tea with mujahedeen is better than anything I’ve ever experienced in my whole life … I lived in America! I know how it is. You have all the fancy amusement parks, and the restaurants, and the food, and all this crap and the cars and you think you’re happy. You’re not happy, you’re never happy. I was never happy. I was always sad and depressed. Life sucked … All you do is work 40, 50, 60 hours a week. [Now] I see paradise and I can smell paradise.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPigraph-2"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("ONER ")]), _vm._v("M"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("OHAMMED ")]), _vm._v("A"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("BU-")]), _vm._v("S"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("ALHA")]), _c('br'), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("American al Qaeda suicide bomber"), _c('br'), _vm._v("seconds before blowing himself up")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Epigraph"
  }, [_vm._v("“The history of our race, and each individual’s experience, is sown thick with evidences that a truth is not hard to kill, and that a lie told well is immortal.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPigraph-2"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("ARK ")]), _vm._v("T"), _c('span', {
    staticClass: "orim-small-caps"
  }, [_vm._v("WAIN")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486f5c61","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Jacobson_LostCodex_1P-2.vue
// module id = 75
// module chunks = 0